import { isNeString } from '@aretheyhappy/utils';
import TableEngine, { ColHelper, ColGroupHelper } from './AgGridTableEngine';
import { TABLE_COLUMN_TYPES, TABLE_SORT_TYPES } from './TableUtils';
/**
 * Converts the old TableField and TableSuperHeader format to AG Grid Engine types
 */
class TableEngineConverter {
    constructor() { }
    static convert(tableFields, tableSuperHeaders) {
        const engine = new TableEngine();
        // Create a map of tableFields by their key for easy lookup
        const fieldMap = new Map();
        tableFields.forEach(field => {
            fieldMap.set(field.key, field);
        });
        // Create a map to track which fields have been added to groups
        const addedToGroups = new Set();
        // Process super headers and their child fields
        tableSuperHeaders.forEach(superHeader => {
            const colGroupHelper = new ColGroupHelper();
            // Set super header properties
            if (superHeader.title) {
                colGroupHelper.setHeaderName(superHeader.title);
            }
            // Find child fields for this super header
            // Assuming child_count indicates how many consecutive fields belong to this header
            let childFieldCount = 0;
            for (const field of tableFields) {
                if (childFieldCount >= superHeader.child_count)
                    break;
                if (!addedToGroups.has(field.key)) {
                    const colHelper = createColHelper(field);
                    colGroupHelper.addChild(colHelper);
                    addedToGroups.add(field.key);
                    childFieldCount++;
                }
            }
            // Only add group if it has children
            if (colGroupHelper.colDef.children && colGroupHelper.colDef.children.length > 0) {
                engine.addCol(colGroupHelper);
            }
        });
        // Add remaining fields that weren't part of any super header
        tableFields.forEach(field => {
            if (!addedToGroups.has(field.key)) {
                const colHelper = createColHelper(field);
                engine.addCol(colHelper);
            }
        });
        return engine;
    }
}
/**
 * Helper function to create a ColHelper from a TableField
 * @param field The TableField to convert
 * @returns A configured ColHelper instance
 */
function createColHelper(field) {
    const colHelper = new ColHelper();
    // Set header name from title
    if (field.title) {
        colHelper.setHeaderName(field.title);
    }
    // Set tooltip from description
    if (isNeString(field.description)) {
        colHelper.setTooltip(field.description);
    }
    // Set sortable based on sort_enabled
    colHelper.setSortable(field.sort_enabled);
    // Set pinned for locked columns
    if (field.locked) {
        colHelper.setPinned('left');
    }
    switch (field.type) {
        case TABLE_COLUMN_TYPES.BADGE:
        case TABLE_COLUMN_TYPES.BUTTON:
        case TABLE_COLUMN_TYPES.DROPDOWN:
            break;
        case TABLE_COLUMN_TYPES.BREAKDOWN:
            colHelper.setField(field.value_prop_name);
            break;
        case TABLE_COLUMN_TYPES.CHECKBOX:
            colHelper.setField(field.value_prop_name);
            break;
        case TABLE_COLUMN_TYPES.NUMBER:
        case TABLE_COLUMN_TYPES.NUMBER_BASIC:
            colHelper.setField(field.value_prop_name);
            if (field.sort_type === TABLE_SORT_TYPES.NUMERIC)
                colHelper.setDataType('number');
            else
                colHelper.setDataType('text');
            break;
        case TABLE_COLUMN_TYPES.TEXT:
        case TABLE_COLUMN_TYPES.TITLE:
            colHelper.setField(field.value_prop_name);
            colHelper.setDataType('text');
            break;
        default:
            break;
    }
    return colHelper;
}
export { TableEngineConverter };
export default TableEngineConverter;
//# sourceMappingURL=TableEngineConverter.js.map